import { InfoWithVideoGallery } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'

export interface IAttributes extends ICTAAttributes {
  title: React.ReactNode
  paragraph: React.ReactNode
  tagline?: React.ReactNode
  sublabel?: React.ReactNode
  background: 'white' | 'blue'
  videos: {
    videoUrl: string
    placeholderUrl: string
    placeholderId: number
    isPortrait?: boolean
  }[]
}

export type Video = IAttributes['videos'][0]

const InfoWithVideoGallerySectionBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes
  const { callToAction } = useCTAAttributes(attributes)

  return (
    <InfoWithVideoGallery
      title={attributes.title}
      paragraph={attributes.paragraph}
      tagline={attributes.tagline}
      sublabel={attributes.sublabel}
      videos={attributes?.videos ?? []}
      callToAction={callToAction}
      background={attributes.background}
    />
  )
}

export default InfoWithVideoGallerySectionBlock
